import * as Sentry from '@sentry/react';

/** AI-Generated Documentation - Please Read with Caution */

/** Logs an error to Sentry with proper error formatting */
const logErrorToSentry = (error: $TSFixMe) => {
  if (typeof error === 'object' && error !== null && !(error instanceof Error)) {
    Sentry.captureException(new Error(JSON.stringify(error)));
  } else {
    Sentry.captureException(error);
  }
};

export default logErrorToSentry;
